import { useLayoutEffect } from "react";
import { useLocation } from "react-router-dom";
import { parseUiLocaleFromSearch } from "./urlLocale";
import { setUiLocale } from "./config";

/**
 * Aplica ?lang= / ?locale= / ?lng= / ?ui_lang= em qualquer rota (login ou logado).
 * Campanhas: https://.../login?c=workspace&lang=es
 */
export default function UrlLocaleSync() {
  const { search } = useLocation();

  useLayoutEffect(() => {
    const code = parseUiLocaleFromSearch(search);
    if (code) setUiLocale(code);
  }, [search]);

  return null;
}
